import { useState } from "react";
import { Box, useThemeUI } from "theme-ui";
import { useSelector } from "react-redux";
import get from "lodash/fp/get";

import {
  setCustomisationStage,
  displayCustomisationsCompleteModal,
  setShowReviewOrderPage,
} from "store/app/appSlice";
import { selectProductHeaderProps } from "store/app";
import { Header, LoadingIndicator, StageBar, FooterSelector } from "components";

import ReviewOrderButton from "./ReviewOrderButton";
import CustomisationsContainer from "./CustomisationsContainer";
import ProductImageContainer from "./ProductImageContainer";
import ReviewOrderPage from "./ReviewOrderPage";
import * as styles from "./Product.styles";
import * as stylesV2 from "./ProductV2.styles";

export default function ProductV2({
  restrictedModeEnabled,
  isAddingProductToOrder,
  customisations,
  changeProduct,
  appHeaderLogo,
  appDivider,
  selectedCustomisationId,
  userChoiceValues,
  selectedImageViewAngle,
  imageViewAnglesObj,
  showChangeImageAngleArrowButtons,
  publicDirectoryUrl,

  dispatchSetCustomisationId,
  dispatchSetSelectedImageAngle,
  dispatch,
}) {
  const {
    theme: { isDesktop },
  } = useThemeUI();

  const { backgroundColour } = useSelector(selectProductHeaderProps);

  const showReviewOrderPage = useSelector(get(["app", "showReviewOrderPage"]));

  const [readyToOrder, setReadyToOrder] = useState(false);

  const dispatchSetCustomisationStage = (stage) => {
    dispatch(setCustomisationStage(stage));
  };

  const handleExitReviewPage = () => {
    dispatch(setShowReviewOrderPage(false));
    dispatchSetCustomisationStage(2);
  };

  const handleResetReviewPage = () => {
    setReadyToOrder(false);
    dispatchSetCustomisationStage(3);
  };

  const handleGoBack = () => {
    if (showReviewOrderPage && readyToOrder) {
      return handleResetReviewPage();
    }
    if (showReviewOrderPage) {
      return handleExitReviewPage();
    }
    return changeProduct();
  };

  const customisationCompleteModalShown = useSelector(
    get(["app", "customisationCompleteModalShown"])
  );

  const dispatchCustomisationsCompleteModal = () =>
    dispatch(displayCustomisationsCompleteModal());

  return (
    <>
      {isAddingProductToOrder && (
        <Box sx={styles.loadingIndicatorContainer}>
          <LoadingIndicator />
        </Box>
      )}

      <Box sx={stylesV2.gridLayoutV2({ showReviewOrderPage })}>
        <Box
          sx={styles.productDetailsHeader({
            backgroundColour,
          })}
        >
          <Header goBackTo={handleGoBack} appHeaderLogo={appHeaderLogo} />
        </Box>

        {showReviewOrderPage && (
          <>
            <ReviewOrderPage
              appDivider={appDivider}
              readyToOrder={readyToOrder}
              setReadyToOrder={setReadyToOrder}
              setShowReviewOrderPage={setShowReviewOrderPage}
              appHeaderLogo={appHeaderLogo}
              publicDirectoryUrl={publicDirectoryUrl}
            />
            <FooterSelector />
          </>
        )}

        {!showReviewOrderPage && (
          <>
            <Box sx={{ position: "relative" }}>
              <Box sx={stylesV2.productContainerV2}>
                {!restrictedModeEnabled && (
                  <ReviewOrderButton
                    customisationCompleteModalShown={
                      customisationCompleteModalShown
                    }
                    dispatchCustomisationsCompleteModal={
                      dispatchCustomisationsCompleteModal
                    }
                    userChoiceValues={userChoiceValues}
                  />
                )}
              </Box>

              <ProductImageContainer
                selectedImageViewAngle={selectedImageViewAngle}
                imageViewAnglesObj={imageViewAnglesObj}
                setSelectedImageAngle={dispatchSetSelectedImageAngle}
                showChangeImageAngleArrowButtons={
                  showChangeImageAngleArrowButtons
                }
              />
            </Box>

            <CustomisationsContainer
              customisations={customisations}
              selectedCustomisationId={selectedCustomisationId}
              userChoiceValues={userChoiceValues}
              dispatchSetCustomisationId={dispatchSetCustomisationId}
            />

            {!isDesktop && (
              <Box sx={styles.bottomBarContainer}>
                <StageBar />
              </Box>
            )}
          </>
        )}
      </Box>
    </>
  );
}
